import { ModeEdit } from "@mui/icons-material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { IPeopleListResponseDto } from "../../../shared/services/api/people/types";

export type PeopleMenuModalType = "details" | "cancel" | "resendEmail" | "manualPayment" | "pdf" | "export" | "launch";

interface PeopleMenuProps {
	anchorEl: null | HTMLElement;
	open: boolean;
	onClose: () => void;
	selectedRow: IPeopleListResponseDto | null;
	onOpenModal: (type: PeopleMenuModalType, row: IPeopleListResponseDto) => void;
}

export const PeopleMenuTable = ({ anchorEl, open, onClose, selectedRow, onOpenModal }: PeopleMenuProps) => {
	if (!selectedRow) return null;

	
	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("details", selectedRow);
				}}
			>
				<ListItemIcon>
					<ModeEdit fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Alterar" />
			</MenuItem>

			<Divider />

			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("launch", selectedRow);
				}}
				disabled
			>
				<ListItemIcon>
					<RocketLaunchIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Desativar" />
			</MenuItem>
		</Menu>
	);
};
